export default "__VITE_ASSET__BeG9z1Xq__"